define([
    'mixins/models/projectbased',
    'appcontext'
], (Model, appContext) => Model.extend({

    parse (response) {
        const channels = appContext.channels();

        response.labels = _.sortBy(response.labels, (label) => {
            const channel = channels.where({display_name: label});
            return !_.isEmpty(channel) ? channel[0].get('id') : Infinity;
        });

        return Model.prototype.parse.call(this, response);
    }
}));
